var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.8 27.2",
    style: {
      enableBackground: "new 0 0 26.8 27.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#999999;}\n\t.st1{fill:#FF6666;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1552_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1559_",
    className: "st0",
    d: "M18.5,25.4H1.8V1.9h16.8v5.8l1.8-1.8V1c0-0.5-0.4-0.9-0.9-0.9H0.9C0.4,0.1,0,0.5,0,1v25.3 c0,0.5,0.4,0.9,0.9,0.9h18.5c0.5,0,0.9-0.4,0.9-0.9v-9.8l-1.8,1.8L18.5,25.4L18.5,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1558_",
    className: "st0",
    d: "M15.9,4H4.4C4,4,3.7,4.3,3.7,4.7c0,0.4,0.3,0.7,0.7,0.7h11.5c0.4,0,0.7-0.3,0.7-0.7 C16.6,4.3,16.3,4,15.9,4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1557_",
    className: "st0",
    d: "M16.6,8.3c0-0.4-0.3-0.7-0.7-0.7H4.4C4,7.7,3.7,8,3.7,8.3C3.7,8.7,4,9,4.4,9h11.5 C16.3,9,16.6,8.7,16.6,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1556_",
    className: "st0",
    d: "M14.9,11.3H4.4c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7h9.2L14.9,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1555_",
    className: "st0",
    d: "M11.1,15.8c0.1-0.3,0.2-0.6,0.4-0.9H4.4c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7H11 L11.1,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1554_",
    className: "st0",
    d: "M4.4,18.6c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7h6c-0.2-0.4-0.2-0.9-0.1-1.4H4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1553_",
    className: "st1",
    d: "M26.3,5.3c-0.4-0.4-0.8-0.6-1.3-0.6c-0.5,0-1,0.2-1.3,0.6L13.5,15.4c-0.3,0.3-0.5,0.6-0.6,1 L12.1,19c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0,0.1,0l2.7-0.8c0.4-0.1,0.7-0.3,1-0.6L26.3,8 c0.4-0.4,0.6-0.8,0.6-1.3C26.8,6.1,26.6,5.6,26.3,5.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypography);
export default __webpack_public_path__ + "static/media/typography.238d7b72cfd7423d04309c7206e89b79.svg";
export { ForwardRef as ReactComponent };